module.exports = __webpack_public_path__ + "img/summaryT.5dd9cec8.png";